import { createContext, useState, useEffect } from "react";
import { RefreshToken } from "../api/axiosLogin";
import { getNotifications } from "../api/axiosNotifications";


const DataContext = createContext({});

export const DataProvider = ({ children }) => {
    const [posts, setPosts] = useState([]);
    const [post, setPost] = useState({});
    const [users, setUsers] = useState([]);
    const [roles, setRoles] = useState([]);
    const [fetcherror, setFetcherror] = useState("");
    const [isLoading, setIsLoading] = useState(true);
    const [countries, setCountries] = useState([]);
    const [zones, setZones] = useState([]);
    const [regions, setRegions] = useState([]);
    const [districts, setDistricts] = useState([]);
    const [wards, setWards] = useState([]);
    const [broadCategories, setBroadCategories] = useState([]);
    const [categories, setCategories] = useState([]);
    const [subCategories, setSubCategories] = useState([]);
    const [rights, setRights] = useState([]);
    const [religions, setReligions] = useState([]);
    const [tribes, setTribes] = useState([]);
    const [educationLevels, setEducationLevels,] = useState([]);
    const [employmentStatuses, setEmploymentStatuses] = useState([]);
    const [employmentSectors, setEmploymentSectors] = useState([]);
    const [maritalStatuses, setMaritalStatuses] = useState([]);
    const [marriageTypes, setMarriageTypes] = useState([]);
    const [vulnerabilities, setVulnerabilities] = useState([]);
    const [disabilities, setDisabilities] = useState([]);
    const [messageSubmissions, setMessageSubmissions] = useState([]);
    const [portalSubmissions, setPortalSubmissions] = useState([]);
    const [kits, setKits] = useState([]);
    const [reports, setReports] = useState([]);
    const [userManuals, setUserManuals] = useState([]);
    const [manuals, setManuals] = useState([]);
    const [incidentStatuses, setIncidentStatuses] = useState([]);
    const [incidentResponseStatuses, setIncidentResponseStatuses] = useState([]);

    const [noficationCount, setNoficationCount] = useState({});
    const [isUserAuntheticated, setIsUserAuntheticated] = useState(false);
    const [auntheticatedUser, setAuntheticatedUser] = useState([]);
    const [accessToken, setAccessToken] = useState(null);
    const [refreshToken, setRefreshToken] = useState(null);
    const [language, setLanguage] = useState("TZ");

    const [notifications, setNotifications] = useState([]);
    const [isLoadingNotifications, setIsLoadingNotifications] = useState(true);
    const [fetcherrorNotifications, setFetcherrorNotifications] = useState(false);
    const [pkid, setPkId] = useState(null);


    // useEffect(() => { 
    //     getNotifications(setNotifications, setIsLoadingNotifications, setFetcherrorNotifications, pkid);
    // }, []);
   
  
    
    return (
        <DataContext.Provider value={{
            posts,setPosts,
            post, setPost,
            roles, setRoles,
            users, setUsers,
            fetcherror,setFetcherror,
            isLoading, setIsLoading,
            countries, setCountries,
            zones, setZones,
            regions, setRegions,
            districts, setDistricts,
            wards, setWards,
            broadCategories, setBroadCategories,
            categories, setCategories,
            subCategories, setSubCategories,
            rights, setRights,
            religions, setReligions,
            educationLevels, setEducationLevels,
            tribes, setTribes,
            employmentStatuses, setEmploymentStatuses,
            employmentSectors, setEmploymentSectors,
            maritalStatuses, setMaritalStatuses,
            marriageTypes, setMarriageTypes,
            vulnerabilities, setVulnerabilities,
            disabilities, setDisabilities,
            messageSubmissions, setMessageSubmissions,
            portalSubmissions, setPortalSubmissions,
            noficationCount, setNoficationCount,
            isUserAuntheticated, setIsUserAuntheticated,
            auntheticatedUser, setAuntheticatedUser,
            accessToken, setAccessToken,
            refreshToken, setRefreshToken,
            language, setLanguage,
            kits, setKits,
            reports, setReports,
            userManuals, setUserManuals,
            manuals, setManuals,
            incidentStatuses, setIncidentStatuses,
            incidentResponseStatuses, setIncidentResponseStatuses,
            notifications, setNotifications,
            isLoadingNotifications, setIsLoadingNotifications,
            fetcherrorNotifications, setFetcherrorNotifications,
        }}>
            { children}
        </DataContext.Provider>
    )
}
 
export default DataContext;